module.exports = __webpack_public_path__ + "static/media/generic_avatar.c933332d.svg";